import { __assign } from "tslib";
import { PROPERTY_ADD_OPERATIONS } from './constants';
export var parseUserProperties = function (event) {
    if (!event.user_properties) {
        return;
    }
    var userPropertiesObj = {};
    var userPropertyKeys = Object.keys(event.user_properties);
    userPropertyKeys.forEach(function (identifyKey) {
        if (PROPERTY_ADD_OPERATIONS.includes(identifyKey)) {
            var typedUserPropertiesOperation = event.user_properties && event.user_properties[identifyKey];
            userPropertiesObj = __assign(__assign({}, userPropertiesObj), typedUserPropertiesOperation);
        }
    });
    return userPropertiesObj;
};
//# sourceMappingURL=helpers.js.map